import { useEffect, useState } from 'react';
import Layout from './Layout';
import Loading from './Loading';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../client/client';
import { useLogin } from '../context/LoginContext';
import './EquipmentForm.css';

const SoftwareForm = () => {
    const [loading, setLoading] = useState(true);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const { getSessionAuth } = useLogin();
    const navigate = useNavigate();

    useEffect(() => {
        const sessionAuth = async () => {
            const session = await getSessionAuth();
            if (session) {
                setLoading(false);
            } else {
                navigate("/", { replace: true });
            }
        };
        sessionAuth();
    }, [getSessionAuth, navigate]);

    const [formData, setFormData] = useState({
        description: '',
        license: '',
        license_duration: '',
        date_expiry: '',
    });

    const [equiposList, setEquiposList] = useState([]);
    const [selectedEquipo, setSelectedEquipo] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data: equiposData, error: equiposError } = await supabase
                    .from('equipos')
                    .select('id, title, attendant')
                    .eq('area', 'ARBITRAJE');

                if (equiposError) {
                    console.error('Error fetching equipos data:', equiposError);
                } else {
                    setEquiposList(equiposData);
                }
            } catch (error) {
                console.error('Error fetching equipos data:', error.message);
            }
        };

        fetchData();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    const handleEquipoChange = (e) => {
        const found = equiposList.find((eq) => eq.id === e.target.value) || null;
        setSelectedEquipo(found);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const { error } = await supabase.from('licencias').upsert([
                {
                    id_equipo:        selectedEquipo?.id || null,
                    equipo_title:     selectedEquipo?.title || '',
                    equipo_attendant: selectedEquipo?.attendant || '',
                    description:      formData.description,
                    license:          formData.license,
                    license_duration: formData.license_duration,
                    date_expiry:      formData.date_expiry,
                },
            ]);

            if (error) {
                console.error('Error updating data:', error);
            } else {
                setShowSuccessDialog(true);
            }
        } catch (error) {
            console.error('Error updating data:', error.message);
        }
    };

    const handleAccept = () => {
        setShowSuccessDialog(false);
        navigate("/equipos");
    };


    return (
        <Layout>
            {loading && <Loading />}
            <form className="equipment-form" onSubmit={handleSubmit}>
                <h1 className='text-3xl font-bold text-[#4691A6] flex justify-center'>SOFTWARE</h1>
                <div className="form-row pt-10">
                    <div className="field">
                        <label className='text-xs font-semibold'>
                            Equipo:
                            <select
                                name="equipo"
                                value={selectedEquipo?.id || ''}
                                onChange={handleEquipoChange}
                            >
                                <option value="" disabled>Selecciona un equipo</option>
                                {equiposList.map((equipo) => (
                                    <option key={equipo.id} value={equipo.id}>
                                        {equipo.title} — {equipo.attendant}
                                    </option>
                                ))}
                            </select>
                        </label>
                    </div>
                </div>
                <div className="form-row pt-4">
                    <div className="field">
                        <label className='text-xs font-semibold'>
                            Descripción de la licencia:
                            <input
                                type="text"
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                            />
                        </label>
                    </div>
                    <div className="field">
                        <label className='text-xs font-semibold'>
                            Licencia:
                            <input
                                type="text"
                                name="license"
                                value={formData.license}
                                onChange={handleChange}
                            />
                        </label>
                    </div>
                    <div className="field">
                        <label className='text-xs font-semibold'>
                            Duración de la icencia:
                            <input
                                type="text"
                                name="license_duration"
                                value={formData.license_duration}
                                onChange={handleChange}
                            />
                        </label>
                    </div>
                    <div className="field">
                        <label className='text-xs font-semibold'>
                            Fecha de expiración:
                            <input
                                type="date"
                                name="date_expiry"
                                value={formData.date_expiry}
                                onChange={handleChange}
                            />
                        </label>
                    </div>
                </div>

                <div className="form-row">
                    <button className="bg-[#356674] hover:bg-[#4691A6] transition-colors duration-300 text-base cursor-pointer mt-7 text-white font-semibold py-2 px-4 rounded-md w-full" type="submit">Guardar</button>
                </div>

                {showSuccessDialog && (
                    <div className="success-dialog">
                        <p>Se ha guardado exitosamente</p>
                        <button onClick={handleAccept} className="bg-[#356674] hover:bg-[#4691A6] transition-colors duration-300 text-base cursor-pointer mt-7 text-white font-semibold py-2 px-4 rounded-md w-full">Aceptar</button>
                    </div>
                )}
            </form>
        </Layout>
    )
}

export default SoftwareForm